import React from 'react'
import { isDw2Repaint } from '../../../../../../experiments/dw2Repaint'
import TParallelButtons from './tParallelButtonsOverpanel'
import TVariantParallelButtons from './tVariantParallelButtonsOverpanel'

const ParallelButtons = props => {
  return isDw2Repaint() ? (
    <TVariantParallelButtons {...props} />
  ) : (
    <TParallelButtons {...props} />
  )
}

export default ParallelButtons
